import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { Input } from '../styledSystem/Input';
import { Label } from '../styledSystem/Text';
import { BoxTemplate } from '../styledSystem/Box';

class FormInput extends React.Component {
    state = {
        hover: false
    };

    handleMouseIn() {
        this.setState({ hover: true });
    }

    handleMouseOut() {
        this.setState({ hover: false });
    }

    onChange = ({ target }) => {
        const { model, name, statevariable } = this.props;
        model[name] = target.value;

        if (model.validate(name) === true) {
            const invalidform = Object.keys(statevariable.formErrors).filter(
                item => statevariable.formErrors[item] !== ''
            );

            if (
                invalidform.length > 1 ||
                (invalidform.length === 1 &&
                    statevariable.formErrors[name] === '')
            ) {
                this.props.updateState({
                    formErrors: {
                        ...this.props.statevariable.formErrors,
                        [name]: ''
                    },
                    formValid: false
                });
            } else {
                this.props.updateState({
                    formErrors: {
                        ...this.props.statevariable.formErrors,
                        [name]: ''
                    },
                    formValid: true
                });
            }
        } else {
            if (statevariable) {
                this.props.updateState({
                    formErrors: {
                        ...this.props.statevariable.formErrors,
                        [name]: model.validate(name)
                    },
                    formValid: false
                });
            }
        }
    };

    render() {
        const { model, name, statevariable, ...props } = this.props;

        const tooltipStyle = {
            display: this.state.hover ? 'block' : 'none',
            position: 'absolute',
            right: 0,
            margin: 0,
            top: '5px',
            backgroundColor: '#c1272d',
            width: '70%',
            padding: '5px'
        };

        let modelname = model[name];
        if (modelname === 'dhcp') modelname = 'DHCP';
        if (modelname === 'static') modelname = 'Static';

        return (
            <div>
                <div
                    onMouseOver={this.handleMouseIn.bind(this)}
                    onMouseOut={this.handleMouseOut.bind(this)}
                >
                    <Input
                        {...props}
                        value={modelname}
                        onChange={this.onChange}
                    />
                </div>
                {this.props.statevariable &&
                this.props.statevariable.formErrors[name] ? (
                    <BoxTemplate position="relative">
                        <BoxTemplate style={tooltipStyle}>
                            <Label color="white" textStyle="labelSmall">
                                {this.props.statevariable.formErrors[name]}
                            </Label>
                        </BoxTemplate>
                    </BoxTemplate>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

FormInput.propTypes = {
    model: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired
};

export default observer(FormInput);



// WEBPACK FOOTER //
// ./src/form/Input.js